/**
 * @generated SignedSource<<e1d733baa0dba8599ec1e2a8306556f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignsDirectory_viewer$data = {
  readonly isDesignsDirectoryQuickJumpDisabled: boolean | null;
  readonly " $fragmentType": "DesignsDirectory_viewer";
};
export type DesignsDirectory_viewer$key = {
  readonly " $data"?: DesignsDirectory_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsDirectory_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignsDirectory_viewer",
  "selections": [
    {
      "alias": "isDesignsDirectoryQuickJumpDisabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "isDesignsDirectoryQuickJumpDisabled"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"isDesignsDirectoryQuickJumpDisabled\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "933ad7e8eef8d6b25aba3ce5f7948022";

export default node;
